var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex gap-2 text-primary" },
        [
          _c("v-icon", { attrs: { color: "primary", size: 20 } }, [
            _vm._v(" mdi-message "),
          ]),
          _c("span", { staticClass: "text-xl font-medium" }, [
            _vm._v("ตั้งค่าข้อความคำสั่งซื้อ"),
          ]),
        ],
        1
      ),
      _c(
        "v-tabs",
        {
          staticClass: "app-tab mt-6",
          attrs: { "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        _vm._l(_vm.tabHeaders, function (header) {
          return _c(
            "v-tab",
            { key: header.id, attrs: { href: `#${header.value}` } },
            [_vm._v(" " + _vm._s(header.title) + " ")]
          )
        }),
        1
      ),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(
            "v-tab-item",
            { attrs: { value: "send" } },
            [_c("send-message")],
            1
          ),
          _c(
            "v-tab-item",
            { attrs: { value: "auto-message" } },
            [_c("auto-message")],
            1
          ),
          _c(
            "v-tab-item",
            { attrs: { value: "message" } },
            [_c("order-message")],
            1
          ),
          _c("v-tab-item", { attrs: { value: "cod" } }, [_c("cod-message")], 1),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }